var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#082CAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2609_5566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.99999H10.1C8.83988 7.99999 8.20982 7.99999 7.72852 8.24522C7.30516 8.46094 6.96095 8.80514 6.74524 9.22851C6.5 9.70981 6.5 10.3399 6.5 11.6V17.9C6.5 19.1601 6.5 19.7902 6.74524 20.2715C6.96095 20.6948 7.30516 21.039 7.72852 21.2548C8.20982 21.5 8.83988 21.5 10.1 21.5H16.4C17.6601 21.5 18.2902 21.5 18.7715 21.2548C19.1948 21.039 19.539 20.6948 19.7548 20.2715C20 19.7902 20 19.1601 20 17.9V14.75M11 17H12.2559C12.6228 17 12.8062 17 12.9788 16.9585C13.1319 16.9218 13.2782 16.8612 13.4124 16.7789C13.5638 16.6862 13.6935 16.5565 13.9529 16.297L21.125 9.12499C21.7463 8.50367 21.7463 7.49631 21.125 6.87499C20.5037 6.25367 19.4963 6.25367 18.875 6.87499L11.7029 14.047C11.4435 14.3065 11.3138 14.4362 11.221 14.5876C11.1388 14.7218 11.0782 14.8681 11.0414 15.0211C11 15.1938 11 15.3772 11 15.7441V17Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2609_5566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/editImage.8a9e3ffbe6f82eba36b2d943bc529fa8.svg";
export { ForwardRef as ReactComponent };